import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, firstValueFrom, Observable, of, tap } from 'rxjs';
import { BYPASS_INTERCEPTOR } from '../lottery/users.service';
import { PrintTicketResponse, RootTicketObject } from '../../models/lottery-ticket/lottery-ticket.model';
import { ResponseModel } from '../../models/base-response.model';
import { ProductType } from '../../enums/base.enums';
import { LotteryService } from '../lottery/lottery.service';

export interface Printer{
  name:string,
  status:string
}

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private apiUrl = 'http://localhost:10021';

  constructor(
    private http: HttpClient,
    private _lotteryService:LotteryService,
  ) {}

  obtenerMacAddress(): Promise<string> {
    return firstValueFrom(
      this.http.get<string>(`${this.apiUrl}/get-info`, {
        responseType: 'text' as 'json' ,
        context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
      })
    );
  }

  getAvailablePrinters(): Observable<Printer[]> {
    return this.http.get<Printer[]>(`${this.apiUrl}/get-printers`, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
        context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
      })
  }

  getDefaultPrinter(): Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/get-printer`, {
      responseType: 'text' as 'json' ,
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
    })
  }

  printTicket(ticket:RootTicketObject<any>) {
    return this.http.post<ResponseModel<PrintTicketResponse>>(`${this.apiUrl}/print-ticket`,ticket, {
      headers: new HttpHeaders({
          'Content-Type': 'application/json',
      }),
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
    })
  }

  refreshPrinter() {
    return this.http.get<string>(`${this.apiUrl}/refresh-printer`, {
      responseType: 'text' as 'json' ,
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
    })
  }

  printTicketImage(base64: string,ticketId:string = '') {
    return this.http.post<PrintTicketResponse>(`${this.apiUrl}/print-ticket`,{image:base64}, {
      context: new HttpContext().set(BYPASS_INTERCEPTOR, true)
    })
  }

  printAndLogTicket(
    base64: string,
    ticketId: string = '',
    type: ProductType = ProductType.Lottery
  ): Observable<PrintTicketResponse> {
    const userTerminalId = localStorage.getItem("UTId") ?? '';

    // Proceso de impresión del ticket
    return this.printTicketImage(base64, ticketId).pipe(
      tap((response: PrintTicketResponse) => {
        // Intentar registrar el uso del papel, pero no interrumpir si falla
        this._lotteryService.logPaperUse({
          entityId: ticketId,
          productType: type,
          code: response.code,
          amountPaperUsed: response.paperSize,
          userTerminalId: userTerminalId
        }).subscribe({
          next: () => console.log('Registro de uso de papel exitoso'),
          error: (error) => console.error('Fallo al registrar el uso de papel:', error),
        });
      }),
      catchError((error) => {
        console.error('Error durante el proceso de impresión:', error);
        return of(error); // Manejo de error en la impresión
      })
    );
  }

}
